//https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values

class KeyPattern{
    constructor(key, ctrl=false, alt=false, shift=false) {
        this.altKey = alt;
        this.shiftKey = shift;
        this.ctrlKey = ctrl;
        this.key = key
    }

    toPattern(){
        let pattern = "";
        if(this.ctrlKey){
            pattern = "C+";
        }
        if(this.altKey){
            pattern += "A+";
        }
        if(this.shiftKey){
            pattern += "S+";
        }
        pattern += this.key;
        return pattern.toLowerCase();
    }

}

class _HotKeys{
    constructor() {
        // register the handler
        document.addEventListener('keyup', e => this._docKeyUp(e), false);
        /**
         * @type {Map<string, Function>}
         */
        this.patterns = new Map();
    }

    /**
     * @param {KeyboardEvent} e
     * @private
     */
    _docKeyUp(e) {
        if(!SessionManager.isLoggedIn()){
            return;
        }
        let pattern = "";
        if(e.ctrlKey){
            pattern = "C+";
        }
        if(e.altKey){
            pattern += "A+";
        }
        if(e.shiftKey){
            pattern += "S+";
        }
        pattern += e.key;

        if(!this.patterns.has(pattern.toLowerCase())) {
            return;
        }

        const fun = this.patterns.get(pattern.toLowerCase());
        fun(e);
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        return false;
    }

    /**
     * @param {KeyPattern} keyPattern
     * @param {Function} callback
     */
    register(keyPattern, callback){
        this.patterns.set(keyPattern.toPattern(), callback);
    }
    /**
     * @param {KeyPattern} keyPattern
     */
    unregister(keyPattern){
        if(this.patterns.has(keyPattern.toPattern())) {
            this.patterns.delete(keyPattern.toPattern());
        }
    }
}

const HotKeys = new _HotKeys();
export {HotKeys, KeyPattern};
